import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SearchPref} from '../constants';

export const keywordSearchSuggestionsEnabled = () =>
	getPreference(SearchPref.SUGGESTIONS_ENABLED, true);
